import type { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js'
import type { AngularDimensionEntity } from '@/plugins/cad/module/CADModule/model/entity'
import { AngularDimensionObject } from '@/plugins/cad/module/CADModule/object/entityObject/AngularDimensionObject'
import { BaseObjectManager, HighlightMode } from './BaseObjectManager'

/** 角度标注对象管理器 */
export class AngularDimensionObjectManager extends BaseObjectManager<
  AngularDimensionEntity,
  AngularDimensionObject
> {
  private entityOriginalMaterialMap: Map<string, LineMaterial> = new Map()

  protected createObject(entity: AngularDimensionEntity) {
    const material = this.getCachedMaterial(entity)
    const object = new AngularDimensionObject(entity, material)
    this.entityOriginalMaterialMap.set(entity.id, object.material)
    return object
  }

  protected onUpdateGeometry(entity: AngularDimensionEntity): void {
    const object = this.objectMap.get(entity.id)
    if (!object) {
      return
    }
    object.onUpdateGeometry()
  }

  protected onUpdateMaterial(entity: AngularDimensionEntity): void {
    const object = this.objectMap.get(entity.id)
    if (!object) {
      return
    }
    this.disposeMaterialFromObject(object)
    object.onUpdateMaterial(this.getCachedMaterial(entity))
    this.entityOriginalMaterialMap.set(entity.id, object.material)
    this.updateEntityHighlight(entity)
  }

  protected disposeObject(object: AngularDimensionObject): void {
    this.disposeMaterialFromObject(object)
    object.dispose()
    this.entityOriginalMaterialMap.delete(object.userData.entity.id)
  }

  protected handleEntityHighlight(entity: AngularDimensionEntity, mode: HighlightMode): void {
    const object = this.objectMap.get(entity.id)
    if (!object) {
      return
    }

    if (mode === HighlightMode.None) {
      const material = this.entityOriginalMaterialMap.get(entity.id)!
      object.onUpdateMaterial(material)
      return
    }

    const material =
      mode === HighlightMode.Hover
        ? this.materialManager.getCachedHoverMaterial(entity)
        : this.materialManager.getCachedSelectMaterial(entity)
    object.onUpdateMaterial(material, material.color.getHex())
  }
}
